export default __webpack_public_path__ + "static/Plots0087-670d1ca0c6c95160b52e324b66f14f1e.jpg";